import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { useAuth } from '../context/AuthContext';

// The front door, in the site's voice (it matches auth.elebyte.io, where signing in actually
// happens): black stage, the cursive wordmark, one italic line, one cyan action.
export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  return (
    <Box className="pt-stage">
      <Box className="pt-panel">
        <a className="pt-logo" href="https://elebyte.io" aria-label="Elebyte">
          <span className="pt-logo__mark">
            <img src="/cursive-logo.svg" alt="" />
            <span className="pt-logo__sheen" aria-hidden="true" />
          </span>
        </a>

        <Box sx={{ mt: 3.5, mb: 4 }}>
          <p className="pt-eyebrow">Partners Portal</p>
          <h1 className="pt-title">Welcome back</h1>
          <p className="pt-lede">Sign in to reach the tenant accounts assigned to you.</p>
        </Box>

        <Button variant="contained" size="large" onClick={login} fullWidth>
          Sign In
        </Button>
      </Box>

      <p className="pt-fine">You&apos;ll sign in with your Elebyte account.</p>
    </Box>
  );
}
